//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

    /**
     * Dropdown selector used as a search filter control. unchecked,
     * component removes the provided valeufrom its parent search-filter.
     * @param {Object[]} options - Array of objects for what options should be available from this dropdown
     * @param {string} options[].value - value which the search-filter-dropdown component will output when this option is selected. This can be null or
     * undefined to use this option to clear the value from the filter
     * @param {string} options[].label - label used for this option in the dropdown
     */
  curalate.component('searchFilterDropdown', {
    bindings: {
      options: '<',
      height: '<',
    },
    require: {
      searchFilter: '^searchFilter',
    },
    template: require('@legacy-components/filters/search-filter-dropdown.html'),
    controller: ['$scope',
      function($scope) {
        const self = this;
        $scope.model = {
          height: this.height,
          options: this.options,
          default: null,
        };

        this.$onInit = function() {
          let initialOption;
          const currentSearchFilterValue = self.searchFilter.getValue();

          _($scope.model.options).each((option) => {
            if (option.value !== null) {
              self.searchFilter.registerFilterOptionAlias(option.value, option.label);
            }
          });

          $scope.model.lockedKey = self.searchFilter.isKeyLocked();

          initialOption = _($scope.model.options).find(option => _(currentSearchFilterValue).contains(option.value));

          if (!initialOption) {
                        // default to first value if filter doesn't specify a default
            initialOption = $scope.model.options[0];
          }

          if (initialOption && initialOption.value !== undefined && initialOption.value !== null) {
            $scope.model.default = initialOption.value;
            if (!_(currentSearchFilterValue).contains(initialOption.value)) {
              self.searchFilter.setValue(initialOption.value);
            }
          }

          self.searchFilter.getFilterValueStream().subscribe((newState) => {
                        // When the value stream is updated outside of this directive, set the new value of the dropdown accordingly
                        // Since a dropdown can only have one option set at a time, get the value of the first option if it exists
            const newValue = _(newState).safeGet('0') || null;

            $scope.$broadcast(`dropdown:search-filter-dropdown-${self.searchFilter.key}:changeOption`, { value: newValue });
          });
        };

        this.$onChanges = function(changes) {
          $scope.model.options = changes.options.currentValue;
        };

        $scope.onChange = function(value) {
          const option = _(self.options).find(opt => opt.value === value);

          if (option === null || option === undefined || option.value === null) {
            self.searchFilter.clearValues();
          } else {
            self.searchFilter.setValue(option.value);
          }
        };
      },
    ],
  });
})();
